const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';
import { apiFetch } from './interceptor';

export const hotNumbersApi = {
  getHotNumbers: async (token, params) => {
    try {
      // Build query string from params
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.drawDate) queryParams.append('drawDate', params.drawDate);
      if (params.gameId) queryParams.append('gameId', params.gameId);
      if (params.drawTime) queryParams.append('drawTime', params.drawTime);
      if (params.combination !== undefined) queryParams.append('combination', params.combination);
      
      const url = `${BASE_URL}/hotnumbers?${queryParams.toString()}`;
      
      console.log('Requesting hot numbers from:', url);
      
      const response = await apiFetch(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      // Check if we got a redirected response
      if (response && response.redirected) {
        return { redirected: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching hot numbers:", error);
      throw error;
    }
  }
}; 